import { defineMessages } from 'react-intl';

export default defineMessages({
    unassign: {
        id: 'teacher-footer.components.unassign',
        defaultMessage: 'Unassign'
    },
    unassignTeachers: {
        id: 'teacher-footer.components.unassignTeachers',
        defaultMessage: 'Unassign teachers'
    },
    teachersUnassigned: {
        id: 'teacher-footer.components.teachersUnassigned',
        defaultMessage: 'Teachers have been unassigned'
    },
    selectedTeachersWillBe: {
        id: 'teacher-footer.components.selectedTeacherWillBe',
        defaultMessage: 'The selected teacher(s) will be removed from the school roll.'
    },
    unassigned: {
        id: 'teacher-footer.components.unassigned',
        defaultMessage: 'unassigned'
    },
    loseAccessToProducts: {
        id: 'teacher-footer.components.loseAccessToProducts',
        defaultMessage: 'and will lose all access to their licenced products'
    },
    deleteTeachers: {
        id: 'teacher-footer.components.deleteTeachers',
        defaultMessage: 'Delete Teachers'
    },
    deleteTeachersTitle: {
        id: 'teacher-footer.components.deleteTeachersTitle',
        defaultMessage: 'Do you wish to delete the selected teacher(s) from school roll?'
    },
    teachersDeleted: {
        id: 'teacher-footer.components.teachersDeleted',
        defaultMessage: 'Teacher(s) have been deleted'
    },
    deleteConfirmation: {
        id: 'teacher-footer.components.deleteConfirmation',
        defaultMessage: 'Some teachers are assigned to classes in other products, please confirm to delete from School Roll entirely.'
    },
    removedFromSchool: {
        id: 'teacher-footer.components.removedFromSchool',
        defaultMessage: 'and removed from school roll for all classes and products'
    },
    wishToDelete: {
        id: 'teacher-footer.components.wishToDelete',
        defaultMessage: 'Do you wish to delete the selected teacher(s) from school roll?'
    },
    bulkPasswordChange: {
        id: 'teacher-footer.components.bulkPasswordChange',
        defaultMessage: 'Bulk Password Change'
    },
    bulkPasswordChangeSuccess: {
        id: 'teacher-footer.components.bulkPasswordChangeSucess',
        defaultMessage: 'Passwords have been updated'
    },
    sendVerificationEmails: {
        id: 'teacher-footer.components.sendVerificationEmails',
        defaultMessage: 'Send verification emails'
    }
});



// WEBPACK FOOTER //
// ./app/components/teacher-footer/messages.js